import React, { useEffect, useState } from "react";
import PromoTemplate from "../../components/PromoTemplate";
import { db } from "../../firebase/firebase";
import { doc, getDoc } from "firebase/firestore";

function MulherPerfumes() {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    async function load() {
      try {
        const ref = doc(db, "campaigns", "perfumesdasdivas");
        const snap = await getDoc(ref);

        if (snap.exists()) {
          setConfig(snap.data());
        } else {
          console.warn("Documento 'mulher' não encontrado em campaigns");
        }
      } catch (err) {
        console.error("Erro ao carregar config da página Mulher:", err);
      }
    }

    load();
  }, []);

  if (!config) return <div>Carregando...</div>;

  // 🔥 Override exclusivo da página de mulher
  const finalConfig = {
    ...config,
    textColor: "#f776af",   // cor principal da fonte
    // Exemplo: se quiser alterar o topo por página, pode criar textColorTop no template depois
    // textColorTop: "#ffffff",

    // 👇 CONTROLES DE VISIBILIDADE (opcional, podem vir do Firestore também)
    // se você não passar, o PromoTemplate usa "true" como padrão
    showTopBar: true,
    showDiscountBadge: true,
    showSocialProof: false,
    showSocialProoffeminino: true,
    showSpotsSection: true,
    showBenefitsSection: true,
    logofinalfeminino: true,
  };

  return (
    <>
      {/* Notificação de Prova Social */}
      {/* <LiveJoinNotification /> */}

      {/* Página principal */}
      <PromoTemplate config={finalConfig} />
    </>
  );
}

export default MulherPerfumes;
